<template>
  <div class="mogujia-page">
    <div class="mogujia-follow-content">
      <div class="mogujia-follow-logo-wrap">
        <img class="mogujia-follow-logo" src="/static/images/mogujia/logo.png" alt="iDoeeoD">
      </div>

      <img class="mogujia-follow-title" src="/static/images/mogujia/guanfangfuwu.png" alt="iDoeeoD 官方服务">
      <img class="mogujia-follow-tip" src="/static/images/mogujia/touch.png" alt="扫码或长按添加您的专属客服">
      <div class="mogujia-follow-qrcode-wrap">
        <img class="mogujia-follow-qrcode" src="/static/images/mogujia/wecom.png" alt="企业微信二维码">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoGuJiaFollow'
}
</script>

<style scoped>
.mogujia-page {
  min-height: 100vh;
  min-height: 100dvh;
  height: 100vh;
  height: 100dvh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: clamp(44px, 12vh, 92px) 24px 24px;
  box-sizing: border-box;
  overflow: hidden;
  background: rgb(241, 237, 229);
}

.mogujia-follow-content {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mogujia-follow-logo-wrap {
  width: clamp(98px, 26vw, 136px);
  height: clamp(98px, 26vw, 136px);
  margin-top: clamp(22px, 4.8vh, 40px);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
}

.mogujia-follow-logo {
  width: clamp(65px, 16.8vw, 90px);
  display: block;
}

.mogujia-follow-title {
  width: clamp(114px, 30vw, 160px);
  margin-top: clamp(18px, 5vw, 28px);
  display: block;
}

.mogujia-follow-tip {
  width: clamp(158px, 42vw, 224px);
  margin-top: clamp(84px, 21vw, 140px);
  display: block;
  transform: scaleY(1);
  transform-origin: center top;
}

.mogujia-follow-qrcode-wrap {
  margin-top: clamp(34px, 8.4vw, 46px);
}

.mogujia-follow-qrcode {
  width: clamp(124px, 32vw, 176px);
  display: block;
}

@media (max-width: 480px) {
  .mogujia-page {
    padding: clamp(38px, 10vh, 72px) 20px 20px;
  }

  .mogujia-follow-logo-wrap {
    width: clamp(92px, 27vw, 116px);
    height: clamp(92px, 27vw, 116px);
    margin-top: clamp(18px, 4.2vh, 30px);
  }

  .mogujia-follow-logo {
    width: clamp(61px, 17.6vw, 78px);
  }

  .mogujia-follow-title {
    width: clamp(110px, 32vw, 138px);
    margin-top: 20px;
  }

  .mogujia-follow-tip {
    width: clamp(152px, 43vw, 188px);
    margin-top: clamp(74px, 19vw, 104px);
  }

  .mogujia-follow-qrcode-wrap {
    margin-top: 32px;
  }

  .mogujia-follow-qrcode {
    width: clamp(118px, 34vw, 150px);
  }
}

@media (max-height: 580px) {
  .mogujia-page {
    padding: 26px 18px 18px;
  }

  .mogujia-follow-logo-wrap {
    width: clamp(84px, 23vw, 102px);
    height: clamp(84px, 23vw, 102px);
    margin-top: 16px;
  }

  .mogujia-follow-logo {
    width: clamp(57px, 15.8vw, 70px);
  }

  .mogujia-follow-title {
    width: clamp(102px, 28vw, 124px);
    margin-top: 16px;
  }

  .mogujia-follow-tip {
    width: clamp(142px, 39vw, 168px);
    margin-top: clamp(54px, 13vh, 80px);
  }

  .mogujia-follow-qrcode-wrap {
    margin-top: 28px;
  }

  .mogujia-follow-qrcode {
    width: clamp(108px, 30vw, 130px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MoGuJia/Follow.vue